import { d as dev } from "../../../../chunks/index4.js";
import { c as getMainAlertContent, b as getMainAlertVisibility } from "../../../../chunks/db.js";
const csr = dev;
const prerender = false;
async function load() {
  const alertContent = await getMainAlertContent();
  const alertVisibility = await getMainAlertVisibility();
  return {
    alert: {
      content: alertContent,
      visible: alertVisibility
    }
  };
}
export {
  csr,
  load,
  prerender
};
//# sourceMappingURL=_page.server.ts.js.map
